import { gql } from "@apollo/client";

const CREATE_LEAGUE_MEMBER = gql`
  mutation createLeagueMember(
    $member: Int
    $memberPublicId: String
    $role: [Int!]
    $leagues: [Int!]
    $leaguePublicIds: [String!]
    $organizationName: String
    $organizationEmail: String
    $isOrganization: Boolean
    $organizationPhone: String
    $organizationLogo: Upload
    $displayMember: Boolean #$platformId: Float
  ) {
    createLeagueMember(
      createLeagueMemberInput: {
        member: $member
        memberPublicId: $memberPublicId
        role: $role
        leagues: $leagues
        leaguePublicIds: $leaguePublicIds
        organizationName: $organizationName
        organizationEmail: $organizationEmail
        isOrganization: $isOrganization
        organizationPhone: $organizationPhone
        organizationLogo: $organizationLogo
        displayMember: $displayMember
      } #platformId: $platformId
    ) {
      id
    }
  }
`;

export default CREATE_LEAGUE_MEMBER;
